jQuery(function($) {

  $('.submit-need-modal--exit').click(function() {
    $('#submitNeedModal').modal('hide')
  })

})
